// @flow

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { TweenMax, Linear } from 'gsap';

type Props = {
  duration: number,
  pollTimestamp?: number | Date,
  showOutline?: boolean,
  size?: number,
  strokeWidth?: number,
};

type State = {
  pathString: string,
};

const defaultProps = {
  pollTimestamp: 0,
  showOutline: true,
  size: 20,
  strokeWidth: 1,
};

class PollingCircle extends Component<Props, State> {
  props: Props;
  state: State = {
    pathString: '',
  };

  componentDidMount() {
    const { duration } = this.props;

    this.tweener = TweenMax.to({
      value: 0,
    }, duration, {
      value: 0.999,
      ease: Linear.easeNone,
      onUpdate: this.updateCircle,
      onUpdateParams: ['{self}'],
      onUpdateScope: this,
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.pollTimestamp !== this.props.pollTimestamp) {
      this.tweener.totalDuration(nextProps.duration).restart();
    }
  }

  componentWillUnmount() {
    this.tweener.kill();
  }

  tweener: Object;

  updateCircle(tween) {
    const {
      size = defaultProps.size,
      strokeWidth,
    } = this.props;
    const gap = (strokeWidth + 1) * 2;
    const r = (size / 2) - gap;
    const x = r + gap;
    const y = r + gap;
    const startAngle = 0;
    const endAngle = Math.PI * 2 * tween.target.value;
    const largeArc = endAngle - startAngle <= Math.PI ? 0 : 1;
    const pathString = ['M', x, y,
      'L', x + (Math.cos(startAngle) * r), y - (Math.sin(startAngle) * r),
      'A', r, r, 0, largeArc, 0, x + (Math.cos(endAngle) * r), y - (Math.sin(endAngle) * r),
      'L', x, y,
    ].join(' ');
    this.setState({ pathString });
  }

  render() {
    const {
      showOutline,
      size = defaultProps.size,
      strokeWidth = defaultProps.strokeWidth,
    } = this.props;

    const { pathString } = this.state;

    return (
      <svg
        viewBox={`0 0 ${size} ${size}`}
        style={{
          height: `${size}px`,
          transform: 'rotate(-90deg) scaleY(-1)',
          width: `${size}px`,
        }}
      >
        <path d={pathString} fill="currentColor" />
        {showOutline && (
          <circle
            cx={size / 2}
            cy={size / 2}
            r={(size / 2) - (strokeWidth * 2)}
            fill="none"
            stroke="currentColor"
            strokeWidth={strokeWidth}
          />
        )}
      </svg>
    );
  }
}

PollingCircle.defaultProps = defaultProps;

function mapStateToProps(state) {
  return {
    duration: state.challenge.pollDuration / 1000,
  };
}

export default connect(mapStateToProps)(PollingCircle);
